import actions from './actions';

const {
  POST_LIST_BEGIN,
  POST_LIST_SUCCESS,
  POST_LIST_ERR,
} = actions;

const initialState = {
  data: null,
  loading: true,
  error: null,
};

const postListReducer = (state = initialState, action) => {
  const { type,data,err } = action;
  switch (type) {
    case POST_LIST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case POST_LIST_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case POST_LIST_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export { postListReducer};
